import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
// import { SharedService } from '../../shared/services/shared';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Subject } from 'rxjs';
@Injectable({ providedIn: 'root' })
export class UserService {
  // host: string = environment.host;
  // ct = new Metadata()
  baseUrl: string;

  constructor(private _http: HttpClient) {
    this.baseUrl = environment.API_SERVER;
  }
  signinEvent: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  emitEvent(event: any) {
    this.signinEvent.next(event);
  }
  getEvent() {
    return this.signinEvent.asObservable();
  }
  getFAQ(payload) {
    const params = new HttpParams()
      .set('sidx', 'dateCreated')
      .set('sord', 'desc')
      .set('rows', '3000')
      .set('page', '1')
      .set('_search', 'true')
      .set('filters', payload.filter);
    return this._http.get(this.baseUrl + '/admin/faq-all/');
  }
  getCountries(payload) {
    const params = new HttpParams()
      .set('sidx', 'countryName')
      .set('sord', 'desc')
      .set('rows', '3000')
      .set('page', '1')
      .set('_search', 'true')
      .set('filters', payload.filter);
    return this._http.get(this.baseUrl + '/public/countries/');
  }

  getStates(payload) {
    const params = new HttpParams()
      .set('sidx', 'stateName')
      .set('sord', 'desc')
      .set('rows', '3000')
      .set('page', '1')
      .set('_search', 'true')
      .set('filters', payload.filter);
    console.log(params);
    return this._http.get(this.baseUrl + '/public/states/', { params: params });
  }

  getOptions(payload) {
    const params = new HttpParams()
      .set('sidx', 'optionId')
      .set('sord', 'desc')
      .set('rows', '3000')
      .set('page', '1')
      .set('_search', 'true')
      .set('filters', payload.filter);
    return this._http.get(this.baseUrl + '/public/options/', {
      params: params,
    });
  }
  emailVerification(payload) {
    return this._http.put(
      `${this.baseUrl}/auth/finalize_email_verification/?token=${payload.token}`,
      payload.body
    );
  }

  userVerification(payload) {
    return this._http.put(
      `${this.baseUrl}/auth/finalize_user_invitation/?token=${payload.token}`,
      payload.body
    );
  }

  companyVerification(payload) {
    return this._http.post(
      `${this.baseUrl}/contractors/${payload.id}/company_verification/`,
      payload.body
    );
  }

  validateForgotPassword(payload) {
    return this._http.post(
      `${this.baseUrl}/auth/validate-old-forgot-password/`,
      payload.body
    );
  }

  voneChangePassword(payload) {
    return this._http.post(
      `${this.baseUrl}/auth/recover-old-contractor-password/`,
      payload.body
    );
  }

  login(payload) {
    return this._http.get(`${this.baseUrl}/auth/login/?token=${payload.token}`);
  }
  loginR(payload) {
    return this._http.get(`${this.baseUrl}/auth/login/?token${payload.token}`);
  }

  auth(payload) {
    return this._http.post(`${this.baseUrl}/identity/v2-login/`, payload.body);
  }

  identityValidate(payload) {
    return this._http.get(`${this.baseUrl}/identity/validate/`);
  }

  identityLogout(payload) {
    return this._http.get(`${this.baseUrl}/identity/logout/`);
  }

  identityContinue(payload) {
    return this._http.get(
      `${this.baseUrl}/identity/continue/?return_url=${payload.return}`
    );
  }

  validateSignUp(payload) {
    return this._http.put(
      `${this.baseUrl}/auth/validate_sign_up_details/?newSignUp=true`,
      payload.body
    );
  }
  validateIRRSignUp(payload) {
    return this._http.get(
      `${this.baseUrl}/ccsp/public/certificate-reference/${payload.irrNumber}/contractor-details`
    );
  }
  validateSignUpFalse(payload) {
    return this._http.put(
      `${this.baseUrl}/auth/validate_sign_up_details/?newSignUp=false`,
      payload.body
    );
  }

  identity(payload) {
    return this._http.get(`${this.baseUrl}/identity/`);
  }

  register(payload) {
    return this._http.post(`${this.baseUrl}/identity/v2-sign-up`, payload.body);
  }

  forgotPassword(payload) {
    return this._http.post(
      `${this.baseUrl}/auth/reset-password/${payload.email}/?g_recaptcha_response=${payload.captcha}`,
      payload.body
    );
  }

  resetPassword(payload) {
    return this._http.put(`${this.baseUrl}/auth/reset-password/`, payload.body);
  }
}
